import { createAsyncThunk } from '@reduxjs/toolkit';
import { saveDraftToStorage } from './storage.js';

// Async thunk to submit a task comment (saves to Firestore if draft is saved)
export const submitTaskComment = createAsyncThunk(
  'projectDraft/submitTaskComment',
  async ({ phaseId, taskId, comment }, { getState, dispatch, rejectWithValue }) => {
    try {
      const state = getState().projectDraft;
      const firestoreId = state.firestoreDraftId;

      // If we have a Firestore ID, save directly to Firebase
      if (firestoreId) {
        const { addTaskCommentToFirebase } = await import('../../../pages/home/Projects/api/projectOperations');
        await addTaskCommentToFirebase(firestoreId, phaseId, taskId, comment);
      }

      // Always update local state immediately for UI responsiveness
      dispatch({ type: 'projectDraft/addTaskComment', payload: { phaseId, taskId, comment } });

      // If no Firestore ID, it's a local draft, just local state update is enough (already done above)
      // But we should trigger a draft save to local storage
      dispatch(saveDraftToStorage());

      return { phaseId, taskId, comment };
    } catch (error) {
      console.error('Failed to submit comment:', error);
      return rejectWithValue(error.message);
    }
  }
);

// Async thunk to toggle comment like
export const toggleCommentLike = createAsyncThunk(
  'projectDraft/toggleCommentLike',
  async ({ phaseId, taskId, commentId, userId }, { getState, dispatch, rejectWithValue }) => {
    try {
      const state = getState().projectDraft;
      const firestoreId = state.firestoreDraftId;

      if (firestoreId) {
        const { toggleTaskCommentLikeInFirebase } = await import('../../../pages/home/Projects/api/projectOperations');
        await toggleTaskCommentLikeInFirebase(firestoreId, phaseId, taskId, commentId, userId);
      }

      // Update local state
      dispatch({ type: 'projectDraft/toggleTaskCommentLike', payload: { phaseId, taskId, commentId, userId } });

      return { phaseId, taskId, commentId, userId };
    } catch (error) {
      console.error('Failed to toggle like:', error);
      return rejectWithValue(error.message);
    }
  }
);
